import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { Lock } from 'lucide-react';
export function OfferBlock() {
  return <section id="comprar" className="py-24 px-6" data-id="element-94">
      <div className="max-w-2xl mx-auto" data-id="element-95">
        <FadeIn data-id="element-96">
          <div className="bg-white border-2 border-[#1C1917] p-8 md:p-12 rounded-sm text-center relative shadow-[8px_8px_0px_0px_#1C1917]" data-id="element-97">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#C26D5C] text-white px-6 py-2 text-sm font-bold tracking-widest uppercase rounded-sm" data-id="element-98">
              Oferta Especial
            </div>

            <h2 className="font-serif text-3xl md:text-4xl mb-4 text-[#1C1917] mt-4" data-id="element-99">
              Recupera el mando de tu vida
            </h2>
            <p className="text-[#4A4541] text-lg mb-8" data-id="element-100">
              Por menos de lo que cuesta un café. Acceso inmediato a la guía
              completa para transformar tu relación con el tiempo y el estrés.
            </p>

            <div className="mb-8" data-id="element-101">
              <span className="text-sm font-medium text-[#736B65] uppercase tracking-wider block mb-2" data-id="element-102">
                Precio de Validación
              </span>
              <div className="text-5xl md:text-6xl font-serif text-[#1C1917]" data-id="element-103">
                $6.39 <span className="text-2xl text-[#736B65]" data-id="element-104">USD</span>
              </div>
            </div>

            <Button href="https://guiadownload.com/products/el-ritual-de-10-minutos-que-cambia-tu-dia" size="lg" fullWidth className="mb-4 text-lg" data-id="element-105">
              Quiero El Ritual de 10 Minutos Ahora
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-[#736B65]" data-id="element-106">
              <Lock className="w-4 h-4" data-id="element-107" />
              <span data-id="element-108">Acceso instantáneo tras el pago seguro.</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}